import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IGetFTPBankListResponse {
  bankCode: string;
  bankName: string;
}

async function GetFTPBankList(): Promise<IGetFTPBankListResponse[]> {
  try {
    const response = await axiosInstance.get(
      "/Reconciliation/GetFtpBankList"
    );
    console.log('data from fe', response);
    return response.data?.data || [];
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any)?.error || ex;
  }
}

export function useGetFTPBankList() {
  return useQuery<IGetFTPBankListResponse[], Error>(
    ["ftpBankList"],
    () => GetFTPBankList(),
    {
      // staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );
}